import { render, staticRenderFns } from "./Shelf.vue?vue&type=template&id=a0c6cc06&scoped=true&"
import script from "./Shelf.vue?vue&type=script&lang=js&"
export * from "./Shelf.vue?vue&type=script&lang=js&"
import style0 from "./Shelf.vue?vue&type=style&index=0&id=a0c6cc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c6cc06",
  null
  
)

export default component.exports